const state = {
    initOrder: {},
    remark: ''
};

const getters = {
    getInitOrder: state => {
        return state.initOrder
    },
    getProduct: state => {
        return state.initOrder.productList
    },
    getRemark: state => {
        return state.remark;
    }
};

const mutations = {
    comInitOrder(state, payload) {
        state.initOrder = payload
    },
    comRemark(state, payload) {
        state.remark = payload
    },
};

const actions = {
    disInitOrder({ commit }, reqData) {
        commit("comInitOrder", reqData);
    },
    disRemark({ commit }, reqData) {
        commit("comRemark", reqData);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};